import { inject, Injectable, signal } from '@angular/core';
import { dsApi, dsDtos } from '@vectronic/openApi-customer';
import { DeviceTypeResolver } from '@vectronic/util';

@Injectable({ providedIn: 'root' })
export class CustomerDeviceTypeResolver extends DeviceTypeResolver {
  private readonly deviceTypeApi = inject(dsApi.DeviceTypesCustomer);
  override readonly deviceTypes = signal<dsDtos.DeviceType[]>([]);

  constructor() {
    super();
    this.deviceTypeApi.getDeviceTypes().subscribe((deviceTypes) => {
      this.deviceTypes.set(deviceTypes);
    });
  }
}
